<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Moderação do Feed</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Moderação</div>
        </div>
      </div>

      <section class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left">
            <div class="appui-search">
              <i class="bx bx-search-alt"></i>
              <input v-model.trim="filters.search" placeholder="Autor ou texto da publicação..." @keyup.enter="load()">
              <button v-if="filters.search" class="appui-search-clear" @click="filters.search = ''; load()"><i class="mdi mdi-close"></i></button>
            </div>
            <select class="appui-select" v-model="filters.feed_id" @change="load()">
              <option value="">Todos os canais</option>
              <option v-for="c in channels" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
            <input type="date" class="appui-select" v-model="filters.created_start" @change="load()" title="Publicados de">
            <input type="date" class="appui-select" v-model="filters.created_end" @change="load()" title="Publicados até">
          </div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="load()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
          </div>
        </div>

        <div v-if="!posts.length" class="appui-inline-empty">Nenhuma publicação encontrada.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Autor</th><th style="width:130px">Canal</th><th style="width:130px">Data</th><th style="width:90px">Curtidas</th><th style="width:110px">Comentários</th><th>Publicação</th><th style="width:170px;text-align:right">Ações</th></tr></thead>
          <tbody>
            <tr v-for="p in posts" :key="p.id">
              <td style="font-weight:500;color:#495057">{{ p.author ? p.author.name : '—' }}</td>
              <td><span v-if="p.channel" class="appui-badge appui-badge--blue">{{ p.channel.name }}</span></td>
              <td style="color:#74788d">{{ fmtDate(p.created_at) }}</td>
              <td style="color:#74788d"><i class="mdi mdi-heart-outline"></i> {{ p.likes_total || 0 }}</td>
              <td style="color:#74788d"><i class="mdi mdi-comment-outline"></i> {{ p.comments_total || 0 }}</td>
              <td style="color:#74788d" :title="p.message">{{ truncate(p.message, 60) }}</td>
              <td style="text-align:right;white-space:nowrap">
                <button class="appui-tbtn appui-tbtn--primary" style="margin-right:6px" @click="view(p)">Visualizar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="removePost(p)">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <!-- Modal detalhe do post + comentários -->
    <b-modal v-model="showModal" title="Publicação" size="lg" hide-footer>
      <div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">
        <span class="appui-avatar" style="width:40px;height:40px;font-size:13px">{{ initials(current.author && current.author.name) }}</span>
        <div>
          <div style="font-weight:600;color:#495057">{{ current.author ? current.author.name : '—' }}</div>
          <div style="font-size:11.5px;color:#adb5bd">{{ current.channel ? current.channel.name : '' }} · {{ fmtDate(current.created_at) }}</div>
        </div>
      </div>
      <p style="background:#f7f8fa;border-radius:8px;padding:12px 14px;color:#495057;font-size:13px;white-space:pre-line">{{ current.message }}</p>
      <div v-if="current.picture || current.video" style="margin-bottom:12px;font-size:12.5px;display:flex;gap:14px">
        <a v-if="current.picture" :href="current.picture" target="_blank" rel="noopener"><i class="mdi mdi-image"></i> Ver foto</a>
        <a v-if="current.video" :href="current.video" target="_blank" rel="noopener"><i class="mdi mdi-video"></i> Ver vídeo</a>
      </div>

      <h3 class="appui-sec-title" style="margin-bottom:8px">Comentários <span class="appui-badge appui-badge--muted">{{ comments.length }}</span></h3>
      <div v-if="!comments.length" style="color:#adb5bd;font-size:12.5px;padding:8px 0 14px">Sem comentários.</div>
      <div v-else style="max-height:280px;overflow-y:auto;margin-bottom:12px">
        <div v-for="c in comments" :key="c.id" style="display:flex;align-items:flex-start;gap:10px;padding:9px 0;border-top:1px solid #f4f5f8">
          <div style="flex:1;min-width:0">
            <span style="font-weight:600;font-size:12px;color:#495057">{{ c.author ? c.author.name : '—' }}</span>
            <span style="font-size:12.5px;color:#74788d;margin-left:6px">{{ c.comment }}</span>
          </div>
          <button class="appui-icon-btn appui-icon-btn--danger" title="Excluir comentário" @click="removeComment(c)"><i class="mdi mdi-trash-can-outline"></i></button>
        </div>
      </div>
      <div class="text-right"><button class="btn btn-light" @click="showModal = false">Fechar</button></div>
    </b-modal>
  </div>
</template>

<script>
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: {},
  name: 'app-feed-moderation',
  data () {
    return {
      posts: [],
      channels: [],
      filters: { search: '', feed_id: '', created_start: '', created_end: '' },
      showModal: false,
      current: {},
      comments: []
    }
  },
  mounted () {
    this.load()
    services.listFeed().then(r => { this.channels = r.data.data }).catch(() => {})
  },
  methods: {
    truncate (s, n) { return (s || '').length > n ? s.slice(0, n) + '...' : (s || '') },
    initials (name) { return (name || '?').trim().split(/\s+/).slice(0, 2).map(w => w.charAt(0).toUpperCase()).join('') },
    fmtDate (d) {
      if (!d) return '—'
      const dt = new Date(String(d).replace(' ', 'T'))
      if (isNaN(dt)) return d
      return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
    },
    load () {
      const params = { limit: 100 }
      if (this.filters.search) params.search = this.filters.search
      if (this.filters.feed_id) params.feed_id = this.filters.feed_id
      if (this.filters.created_start) params.created_start = this.filters.created_start
      if (this.filters.created_end) params.created_end = this.filters.created_end
      services.listFeedPosts(params)
        .then(r => { this.posts = r.data.data })
        .catch(() => errorMessage('Falha ao carregar publicações.', 3000))
    },
    async view (p) {
      this.current = p
      this.comments = []
      this.showModal = true
      try {
        const r = await services.listFeedPostComments(p.id)
        this.comments = r.data.data
      } catch (e) { /* sem comentários */ }
    },
    async removePost (p) {
      const ok = await this.$bvModal.msgBoxConfirm('Excluir esta publicação (e todos os comentários)?', { title: 'Você tem certeza?', okTitle: 'Sim, excluir', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try {
        await services.deleteFeedPost(p.id)
        successMessage('Publicação removida.', 2000)
        this.showModal = false
        this.load()
      } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    async removeComment (c) {
      const ok = await this.$bvModal.msgBoxConfirm('Excluir este comentário?', { okTitle: 'Excluir', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try {
        await services.deleteFeedComment(c.id)
        this.comments = this.comments.filter(x => x.id !== c.id)
        if (this.current) this.current.comments_total = Math.max(0, (this.current.comments_total || 1) - 1)
      } catch (e) { errorMessage('Falha ao remover comentário.', 3000) }
    }
  }
}
</script>
